export const STANDARD_MESSAGES = {
  saveSuccess: 'Rekod berjaya disimpan.',
  updateSuccess: 'Perubahan berjaya dikemas kini.',
  requiredWarning: 'Sila lengkapkan semua medan wajib.',
  saveError: 'Tidak dapat menyimpan rekod. Sila cuba lagi.',
  csvImportInfo: 'Import CSV berjaya diselesaikan.',
};
